import React from "react"
import Dropdown from "semantic-ui-react/dist/es/modules/Dropdown/Dropdown"

export default class DropdownWithRemoteSearch extends React.Component {
  state = {
    loading: false,
    searchResults: []
  }
  debouncer = null

  constructor(props) {
    super(props)
    this.options = props.options
  }

  handleSearch = (e, { searchQuery: query }) => {
    if (query) {
      const { options, remoteSearch } = this.props
      const existingOptionTexts = options
        .concat(this.state.searchResults)
        .map(({ text }) => text.toLowerCase())

      if (
        !existingOptionTexts.some(text => text.includes(query.toLowerCase()))
      ) {
        this.setState({ loading: true })
        if (this.debouncer !== null) {
          clearTimeout(this.debouncer)
        }
        this.debouncer = setTimeout(async () => {
          const searchResults = await remoteSearch(query)
          this.setState({
            loading: false,
            searchResults
          })
        }, 500)
      }
    }
  }
  render = () => {
    const { remoteSearch, options, addItemValue, ...rest } = this.props
    const dropdownOptions = options.concat(this.state.searchResults)
    if (addItemValue) {
      const addItemOption = options.find(({ value }) => value === addItemValue)
      dropdownOptions.splice(
        dropdownOptions.findIndex(({ value }) => value === addItemValue),
        1
      )
      dropdownOptions.push(addItemOption)
    }
    return (
      <Dropdown
        {...rest}
        options={dropdownOptions}
        loading={this.state.loading}
        onSearchChange={this.handleSearch}
      />
    )
  }
}
